export default "/assets/6b4a52c06be8205d469c3f9de583b4f2.png";